<div *ngIf="previewData">
  <h5 class="text-primary fw-semibold mb-1">{{previewData.displayName}}</h5>
  <div>
    <strong>Provider:&nbsp;</strong> <span class="fw-semibold">{{previewData.provider}} </span>
  </div>
  <div>
    <strong>Region:&nbsp;</strong> <span class="fw-semibold">{{previewData.region}}</span>
  </div>
  <div>
    <strong>Size:&nbsp;</strong> <span class="fw-semibold">{{previewData.size}}</span>
  </div>
  <div>
    <strong>
      Storage:&nbsp;
    </strong>
    <span class="fw-semibold">{{previewData.storage}}</span>
  </div>
</div>
